import { render, staticRenderFns } from "./houseManage.vue?vue&type=template&id=244da56a&scoped=true&"
import script from "./houseManage.vue?vue&type=script&lang=js&"
export * from "./houseManage.vue?vue&type=script&lang=js&"
import style0 from "./houseManage.vue?vue&type=style&index=0&id=244da56a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244da56a",
  null
  
)

export default component.exports